class modalHelper {
    constructor() {
        this.init();
    }

    init() {
        $('a[href="#modal-pdf"]').on('click', function (e) {
            e.preventDefault();
            handlePdfModal();
        });

        $('a[href="#modal-pdf-close"]').on('click', function (e) {
            e.preventDefault();
            closePdfModal();
        });

        setTimeout(
            function () {
                var hash = location.hash.replace('#', '');
                if (hash == 'modal-pdf') {
                    handlePdfModal();
                }
            }, 1000);

        function handlePdfModal() {
            $('#modal-pdf').modal('show');
        }
        function closePdfModal() {
            $('#modal-pdf').modal('hide');
        }
    }
}

window.app.add('modal', new modalHelper());